import { Chrome } from "lucide-react";
import { Button } from "@/components/ui/button";

interface GoogleButtonProps {
	onClick: () => void;
	disabled?: boolean;
	children?: React.ReactNode;
}

export function GoogleButton({ onClick, disabled, children }: GoogleButtonProps) {
	return (
		<Button
			type="button"
			variant="outline"
			className="w-full"
			onClick={onClick}
			disabled={disabled}
		>
			<Chrome className="mr-2 size-4" />
			{children || "Continue with Google"}
		</Button>
	);
}
